import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const content = this.props.content;

        const listDom = content.map(item => (
            <div key={item.id} className={styles.list}>
                <a href={item.url} target="_blank" ref={rel}>
                    <img src={item.thumbnails} style={{ width: '235px', height: '130px' }} />
                </a>
                <div className={styles.black_01} />
                <div className={styles.word_01}>
                    <a href={item.url} target="_blank" ref={rel}>
                        {item.title}
                    </a>
                </div>
            </div>
        ));

        return <div className={styles.wrap}>{listDom}</div>;
    }
}

export default errorBoundary(Content);
